/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { Status, z, ZodTypes } from '../zod';

export const UserDashboardGet = {
  id: 'user.dashboard.get',
  tag: 'User',
  summary: 'Get user dashboard',
  description: 'Get user dashboard',
  method: 'get',
  route: () => `/user/dashboard`,
  flags: { isAuthorized: true },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            organizations: z
              .strictObject({
                id: ZodTypes.Id,
                name: ZodTypes.TrimmedString,
                products: z
                  .strictObject({
                    type: ZodTypes.ServiceType,
                    [Status.Creating]: z.number(),
                    [Status.Updating]: z.number(),
                    [Status.Importing]: z.number(),
                    [Status.Running]: z.number(),
                    [Status.Stopping]: z.number(),
                    [Status.Starting]: z.number(),
                    [Status.Stopped]: z.number(),
                    [Status.Unavailable]: z.number(),
                    [Status.Error]: z.number(),
                  })
                  .array(),
              })
              .array(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
